export default "__VITE_ASSET__CPF7RaXy__"